import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { TeamLeaguePlayerStatus } from '@/entities/TeamPlayerInfo';
import { playerStatKeys } from '@/hooks/player/playerStatsKeys';
import { updateTeamPlayerRole, UpdateTeamPlayerRoleRequest } from '@/services/actions/teamLeagueTeamPlayersActions';

interface UpdatePlayerRoleParams {
	organizationId: string;
	teamLeagueId: string;
	teamLeagueTeamId: string;
	playerId: string;
	status: TeamLeaguePlayerStatus;
	seasonId: string;
	lineupStrength?: number;
	prevStatus?: TeamLeaguePlayerStatus;
	prevLineupStrength?: number;
}

export const useUpdatePlayerRoleMutate = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (data: UpdatePlayerRoleParams) => {
			try {
				const bodyData: UpdateTeamPlayerRoleRequest = {
					organizationUuid: data.organizationId,
					teamLeagueUuid: data.teamLeagueId,
					teamLeagueTeamUuid: data.teamLeagueTeamId,
					playerUuid: data.playerId,
					status: data.status,
					lineupStrength: data.lineupStrength
				};

				const apiResponse = await updateTeamPlayerRole(bodyData);

				if (!apiResponse.data?.success) {
					throw new Error('Failed to update player role.');
				}
			} catch (error) {
				throw new Error(`HTTP error ${error}`);
			}
		},
		onSuccess: (_data, { organizationId, teamLeagueId, seasonId, playerId }) => {
			queryClient.invalidateQueries({
				queryKey: playerStatKeys.playerStats(organizationId, teamLeagueId, seasonId, playerId)
			});
			toast.success('Player settings successfully updated.');
		},
		onError: () => {
			toast.error('An error has occurred. Please try again later.');
		}
	});
};
